/**
 * 領域 (カード群・グラフ・表) を影 + スピナーで覆う間か (UI 辞書 components/region-loading.md)。
 *
 * 初回の取得中 (`isPending`) と、 key が変わった後に前の結果を残して取り直している間
 * (`keepPreviousData` による `isPlaceholderData`) に true。 5 秒ごとの自動更新では立てない
 * (覆うと 5 秒ごとに画面が暗くなる)。 この判断の持ち主はここ 1 か所 — 画面ごとに
 * 式を写さず、 各データ取得 hook が `isRegionLoading` として返す。
 */
export const isRegionLoading = (query: {
  isPending: boolean
  isPlaceholderData: boolean
}): boolean => query.isPending || query.isPlaceholderData
